import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MibDotsLoaderComponent } from '@medinbox/angular';

@Component({
  selector: 'mai-chatia-waiting',
  imports: [MibDotsLoaderComponent],
  templateUrl: './chat-waiting.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatAIWaitingComponent {}
